module.exports = __webpack_public_path__ + "img/ss-title.24483f84.png";